<template>
    <v-toolbar-title>
        <router-link to="/">
            <v-img contain class="mt-0" :src="logoPath" width="90px"></v-img>            
        </router-link> 
    </v-toolbar-title>
</template> 

<script>

export default {   

    
    computed: {
        basePath: function(){               
            return process.env.VUE_APP_API_PATH
        }, 
        logoPath: function() {
            return this.basePath + 'storage/images/nblogo.jpg'
            //return ""
        }
        
    },
}
</script>